/**
 * @generated SignedSource<<575a5d252663657d4696fa437751b377>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeaturedDealPageQuery$variables = {
  dealId: string;
};
export type FeaturedDealPageQuery$data = {
  readonly featuredDeal: {
    readonly embedInfo: any | null;
    readonly " $fragmentSpreads": FragmentRefs<"DealAnalysis_featuredDeal" | "Details_featuredDeal" | "FeaturedDealTheSound_featuredDeal" | "Hero_FeaturedDeal">;
  } | null;
};
export type FeaturedDealPageQuery = {
  response: FeaturedDealPageQuery$data;
  variables: FeaturedDealPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "dealId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "dealId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "embedInfo",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ProfileNode",
  "kind": "LinkedField",
  "name": "spotifyProfile",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isVisible",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "soundLink",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releaseType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tracksCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releaseDate",
  "storageKey": null
},
v15 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TrackNodeConnection",
      "kind": "LinkedField",
      "name": "tracks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TrackNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TrackNode",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "trackNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SoundRecordingNode",
                  "kind": "LinkedField",
                  "name": "soundRecording",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isrc",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ReleaseNode",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedDealPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FeaturedDealNode",
        "kind": "LinkedField",
        "name": "featuredDeal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Hero_FeaturedDeal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Details_featuredDeal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DealAnalysis_featuredDeal"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FeaturedDealTheSound_featuredDeal"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FeaturedDealPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "FeaturedDealNode",
        "kind": "LinkedField",
        "name": "featuredDeal",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ArtistNode",
            "kind": "LinkedField",
            "name": "artist",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "managerName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "managerCompany",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "managerLink",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ISRCWeekDataAggregate",
                "kind": "LinkedField",
                "name": "luminateWeekDatas",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "weekStartDay",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "tiktokProfile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TikTokProfileDataNodeConnection",
                    "kind": "LinkedField",
                    "name": "tiktokProfileData",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TikTokProfileDataNodeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TikTokProfileDataNode",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "followerCount",
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserNode",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "lastActiveAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "actor",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/)
                            ],
                            "type": "ArtistNode",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "type": "ActorInterface",
                "abstractKey": "__isActorInterface"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "releases",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v4/*: any*/),
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v15/*: any*/)
                        ],
                        "type": "ReleaseInterface",
                        "abstractKey": "__isReleaseInterface"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UnreleasedReleaseNodeConnection",
            "kind": "LinkedField",
            "name": "unreleasedReleases",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UnreleasedReleaseNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UnreleasedReleaseNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/),
                      (v11/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "indiglyphType",
                        "storageKey": null
                      },
                      (v10/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          (v9/*: any*/),
                          (v15/*: any*/)
                        ],
                        "type": "ReleaseInterface",
                        "abstractKey": "__isReleaseInterface"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalAmountRaising",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "inPocketAmountRaising",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "marketingAmountRaising",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "creativeAmountRaising",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSplitPreRecoupment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSplitPostRecoupment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "termLengthMonths",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SoundRecordingNodeConnection",
            "kind": "LinkedField",
            "name": "soundRecordings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "SoundRecordingNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SoundRecordingNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "whyInvestNow",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "editorialNote",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distributor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distributionAgreement",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "producerAgreement",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastApprovedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TikTokSoundNodeConnection",
            "kind": "LinkedField",
            "name": "tiktokSounds",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "TikTokSoundNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TikTokSoundNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TikTokSoundDataNode",
                        "kind": "LinkedField",
                        "name": "data",
                        "plural": true,
                        "selections": [
                          (v7/*: any*/),
                          (v6/*: any*/),
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "streamsPerDay",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isOfferFeaturedDealInterface"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7ba24456184c0afceef066efb1d78ff2",
    "id": null,
    "metadata": {},
    "name": "FeaturedDealPageQuery",
    "operationKind": "query",
    "text": "query FeaturedDealPageQuery(\n  $dealId: ID!\n) {\n  featuredDeal(id: $dealId) {\n    embedInfo\n    ...Hero_FeaturedDeal\n    ...Details_featuredDeal\n    ...DealAnalysis_featuredDeal\n    ...FeaturedDealTheSound_featuredDeal\n    id\n  }\n}\n\nfragment ArtistThumbnail_featuredDeal on FeaturedDealNode {\n  artist {\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n  releases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        thumbnailUrl\n        id\n      }\n    }\n  }\n}\n\nfragment AvatarIcon_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    lastActiveAt\n    ...useUserThumbnailUrl_user\n    id\n  }\n}\n\nfragment DealAnalysis_featuredDeal on FeaturedDealNode {\n  streamsPerDay\n  releases {\n    edges {\n      node {\n        ... on ReleaseInterface {\n          __isReleaseInterface: __typename\n          name\n          releaseType\n          ...useReleaseMetadata_release\n        }\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        ... on ReleaseInterface {\n          __isReleaseInterface: __typename\n          name\n          releaseType\n          ...useReleaseMetadata_release\n        }\n        id\n      }\n    }\n  }\n  ...ReturnProfile_featuredDeal\n  ...RecoupmentProfile_featuredDeal\n}\n\nfragment Deal_featuredDeal on FeaturedDealNode {\n  totalAmountRaising\n  inPocketAmountRaising\n  marketingAmountRaising\n  creativeAmountRaising\n  partnerSplitPreRecoupment\n  partnerSplitPostRecoupment\n  termLengthMonths\n  artist {\n    ...useMessage_actor\n    ...ReleaseImagesGrid_artist\n    id\n  }\n  soundRecordings {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  releases {\n    edges {\n      node {\n        id\n        __typename\n        isVisible\n        ...ReleaseImagesGrid_releases\n        ...UpdateOrCreateReleaseModal_release\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        __typename\n        name\n        id\n        ...ReleaseImagesGrid_unreleasedReleases\n        ...UpdateOrCreateReleaseModal_release\n      }\n    }\n  }\n}\n\nfragment Details_featuredDeal on FeaturedDealNode {\n  ...Terms_featuredDeal\n  ...WhyInvest_featuredDeal\n  artist {\n    ...KeyPerformanceStats_artist\n    id\n  }\n  ...TikTokData_featuredDeal\n}\n\nfragment FeaturedDealTheSound_featuredDeal on FeaturedDealNode {\n  embedInfo\n}\n\nfragment Hero_FeaturedDeal on FeaturedDealNode {\n  artist {\n    ...Title_artist\n    id\n  }\n  releases {\n    edges {\n      node {\n        ...Title_releases\n        id\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        ...Title_releases\n        id\n      }\n    }\n  }\n  ...Deal_featuredDeal\n  ...ArtistThumbnail_featuredDeal\n}\n\nfragment KeyPerformanceStats_artist on ArtistNode {\n  displayName\n  luminateWeekDatas {\n    value\n    weekStartDay\n  }\n}\n\nfragment RecoupmentProfile_featuredDeal on FeaturedDealNode {\n  totalAmountRaising\n}\n\nfragment ReleaseDetails_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  isVisible\n  name\n  ...useReleaseMetadata_release\n}\n\nfragment ReleaseImagesGrid_artist on ArtistNode {\n  ...useArtistThumbnailUrl_artist\n}\n\nfragment ReleaseImagesGrid_releases on ReleaseNode {\n  id\n  thumbnailUrl\n}\n\nfragment ReleaseImagesGrid_unreleasedReleases on UnreleasedReleaseNode {\n  id\n  thumbnailUrl\n  indiglyphType\n}\n\nfragment ReleasesInfoRemovable_offerFeaturedDeal on OfferFeaturedDealInterface {\n  __isOfferFeaturedDealInterface: __typename\n  soundRecordings {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment ReleasesInfoRemovable_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  id\n  soundLink\n  thumbnailUrl\n  name\n  ... on UnreleasedReleaseNode {\n    __typename\n  }\n  ... on ReleaseNode {\n    __typename\n    tracks {\n      edges {\n        node {\n          name\n          trackNumber\n          soundRecording {\n            id\n            isrc\n          }\n          id\n        }\n      }\n    }\n  }\n  ...ReleaseDetails_release\n}\n\nfragment ReturnProfile_featuredDeal on FeaturedDealNode {\n  termLengthMonths\n  streamsPerDay\n  totalAmountRaising\n  partnerSplitPreRecoupment\n  partnerSplitPostRecoupment\n}\n\nfragment Terms_featuredDeal on FeaturedDealNode {\n  id\n  releases {\n    edges {\n      node {\n        id\n        soundLink\n        ...ReleasesInfoRemovable_release\n      }\n    }\n  }\n  unreleasedReleases {\n    edges {\n      node {\n        id\n        soundLink\n        ...ReleasesInfoRemovable_release\n      }\n    }\n  }\n  termLengthMonths\n  partnerSplitPreRecoupment\n  partnerSplitPostRecoupment\n  artist {\n    ...useMessage_actor\n    ...AvatarIcon_actor\n    slug\n    displayName\n    managerName\n    managerCompany\n    managerLink\n    id\n  }\n  ...ReleasesInfoRemovable_offerFeaturedDeal\n}\n\nfragment TikTokData_featuredDeal on FeaturedDealNode {\n  tiktokSounds {\n    edges {\n      node {\n        data {\n          date\n          value\n          id\n        }\n        id\n      }\n    }\n  }\n  artist {\n    tiktokProfile {\n      tiktokProfileData {\n        edges {\n          node {\n            date\n            followerCount\n            id\n          }\n        }\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment Title_artist on ArtistNode {\n  slug\n  displayName\n}\n\nfragment Title_releases on ReleaseInterface {\n  __isReleaseInterface: __typename\n  name\n  releaseType\n  ...useReleaseMetadata_release\n}\n\nfragment UpdateOrCreateReleaseModal_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  __typename\n  id\n  name\n  releaseType\n  soundLink\n  isVisible\n  tracksCount\n}\n\nfragment WhyInvest_featuredDeal on FeaturedDealNode {\n  whyInvestNow\n  editorialNote\n  distributor\n  distributionAgreement\n  producerAgreement\n  lastApprovedAt\n}\n\nfragment useArtistThumbnailUrl_artist on ArtistNode {\n  thumbnailUrl\n  spotifyProfile {\n    thumbnailUrl\n    id\n  }\n}\n\nfragment useMessage_actor on ActorInterface {\n  __isActorInterface: __typename\n  user {\n    ...useMessage_user\n    id\n  }\n}\n\nfragment useMessage_user on UserNode {\n  id\n}\n\nfragment useReleaseMetadata_release on ReleaseInterface {\n  __isReleaseInterface: __typename\n  releaseType\n  tracksCount\n  releaseDate\n}\n\nfragment useUserThumbnailUrl_user on UserNode {\n  actor {\n    __typename\n    thumbnailUrl\n    ...useArtistThumbnailUrl_artist\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "beb7b40c6b951448dcf5d1bd2ee4803d";

export default node;
